import styles from "./PendingProductReview.module.scss";

const ProductPendingHeader = ({ localProduct }) => {
	return (
		<div className={styles.header}>
			<div className={styles.divHeader}>
				<h4>{localProduct?.label || "Producto pendiente"}</h4>
				<span>Producto a revisar</span>
			</div>
			<div className={`${styles.divHeader} ${styles.status}`}>🟠 Pendiente</div>
		</div>
	);
};

export default ProductPendingHeader;
